export default __webpack_public_path__ + "static/media/headphone.baa12098.svg";